import React from 'react';

const Footer = () => {
  const date = new Date();
  return (
    <div
      data-testid="footer-wrapper"
      className="w-full flex items-center justify-end text-[13px] text-[gray] pr-5 mt-2"
    >
      {`Copyright © ${date.getFullYear()} Excelsoft Technologies Pvt Ltd`}
    </div>
  );
};

export default Footer;
